<template>
  <v-navigation-drawer
    v-model="sidebar"
    app
    temporary
  >
    <v-list>
      <v-list-tile
        v-for="(link, i) in links"
        :key="i"
        :href="link.href"
        @click="goToElement(link)"
      >
        <v-list-tile-title v-text="link.text"/>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'GuestDrawer',
    data: () => ({
      links: [
        {name: 'GuestHome', to: '#welcome', text: 'Home'},
        {name: 'GuestHome', to: '#about', text: 'E-Adoption'},
        {name: 'GuestHome', to: '#impress', text: 'Company Info'},
        {name: 'SignIn', text: 'Login'},
      ],
    }),
    methods: {
      toggleDrawer() {
        this.sidebar = !this.sidebar;
      },
      goToElement(element) {
        if (this.$router.currentRoute.name === element.name) {
          this.$vuetify.goTo(element.to);
        } else {
          this.$router.push({name: element.name, hash: element.to});
        }
      },
    },
    computed: {
      ...mapGetters({
        isAdmin: 'guest/auth/isAdmin',
      }),
      sidebar: {
        get() {
          return this.$store.getters['common/ui/sidebar'];
        },
        set(value) {
          this.$store.dispatch('common/ui/setSidebar', value);
        },
      },
    },
  };
</script>

<style scoped>

</style>
